/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    countryState?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserRequest
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    subscriptionPlanId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    mlsId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    officeName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserRequest
     */
    enabledMlsProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the CreateUserRequest interface.
 */
export function instanceOfCreateUserRequest(value: object): value is CreateUserRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('subscriptionPlanId' in value) || value['subscriptionPlanId'] === undefined) return false;
    return true;
}

export function CreateUserRequestFromJSON(json: any): CreateUserRequest {
    return CreateUserRequestFromJSONTyped(json, false);
}

export function CreateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'countryState': json['countryState'] == null ? undefined : json['countryState'],
        'country': json['country'] == null ? undefined : json['country'],
        'emailConfirmed': json['emailConfirmed'] == null ? undefined : json['emailConfirmed'],
        'subscriptionPlanId': json['subscriptionPlanId'],
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
        'enabledMlsProviders': json['enabledMlsProviders'] == null ? undefined : json['enabledMlsProviders'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}

export function CreateUserRequestToJSON(json: any): CreateUserRequest {
    return CreateUserRequestToJSONTyped(json, false);
}

export function CreateUserRequestToJSONTyped(value?: CreateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'timezone': value['timezone'],
        'countryState': value['countryState'],
        'country': value['country'],
        'emailConfirmed': value['emailConfirmed'],
        'subscriptionPlanId': value['subscriptionPlanId'],
        'mlsId': value['mlsId'],
        'officeName': value['officeName'],
        'enabledMlsProviders': value['enabledMlsProviders'],
        'phoneNumber': value['phoneNumber'],
    };
}

